import React from "react";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Story from "@/components/Story";
import AIDesigner from "@/components/AIDesigner";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import OrderForm from "@/components/OrderForm";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div className="bg-[#F5DCD5] min-h-screen" data-testid="landing-page">
      <Navigation />
      <Hero />
      <Story />
      <AIDesigner />
      <Gallery />
      <Testimonials />
      <OrderForm />
      <Footer />
    </div>
  );
}
